var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row drag-drop"},[_c('div',{staticClass:"col-12"},[_c('section',{ref:"items",staticClass:"draggable-items"}),_c('section',{ref:"pairs",staticClass:"matching-pairs"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }